export default __webpack_public_path__ + "static/media/v-tb-r.5592fcf1.png";